/**
 * Payment Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentSearchResultDTO { 
    id?: number;
    orderCode?: string;
    amount?: number;
    currency?: string;
    payType?: PaymentSearchResultDTO.PayTypeEnum;
    platform?: PaymentSearchResultDTO.PlatformEnum;
    status?: PaymentSearchResultDTO.StatusEnum;
    client?: PaymentSearchResultDTO.ClientEnum;
    providerReference?: string;
    description?: string;
    creationDate?: string;
    lastUpdateDate?: string;
    tenantId?: number;
}
export namespace PaymentSearchResultDTO {
    export const PayTypeEnum = {
        Cash: 'CASH',
        BankTransfer: 'BANK_TRANSFER',
        Card: 'CARD',
        EWallet: 'E_WALLET',
        Cod: 'COD'
    } as const;
    export type PayTypeEnum = typeof PayTypeEnum[keyof typeof PayTypeEnum];
    export const PlatformEnum = {
        Momo: 'MOMO',
        Zalopay: 'ZALOPAY',
        Vnpay: 'VNPAY',
        Stripe: 'STRIPE',
        Cod: 'COD',
        None: 'NONE'
    } as const;
    export type PlatformEnum = typeof PlatformEnum[keyof typeof PlatformEnum];
    export const StatusEnum = {
        Pending: 'PENDING',
        Settled: 'SETTLED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED',
        Refunded: 'REFUNDED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const ClientEnum = {
        Pos: 'POS',
        BackOffice: 'BACK_OFFICE'
    } as const;
    export type ClientEnum = typeof ClientEnum[keyof typeof ClientEnum];
}


